import config from 'config.json';
import 'isomorphic-fetch';
import reduxApi, { transformers } from 'redux-api';

const routes = {
  paises: {
    url: '/paises',
    crud: true,
    transformer: transformers.array
  },
  ciudades: {
    url: '/ciudades',
    crud: true,
    transformer: transformers.array
  },
  sucursales: {
    url: '/sucursales',
    crud: true,
    transformer: transformers.array
  },
  tiposComprobantes: {
    url: '/tipos-comprobantes',
    crud: true,
    transformer: transformers.array
  },
  roles: {
    url: '/roles',
    crud: true,
    transformer: transformers.array
  },
  permisos: {
    url: '/permisos',
    crud: true,
    transformer: transformers.array
  },
  parametros: {
    url: '/parametros',
    crud: true,
    transformer: transformers.array
  },
  especialistas: {
    url: '/empleados',
    crud: true,
    transformer: transformers.array
  },
  paquetesCliente: {
    url: '/paquetes-cliente',
    crud: true,
    transformer: transformers.array
  },
  currentUser: {
    url: '/jwt/user'
  },
  valoresPorTipo: {
    url: '/tipos/:id/valores',
    transformer: transformers.array
  },
  valores: {
    url: '/valores',
    transformer: transformers.array,
    crud: true
  },
  productosAdicionales: {
    url: '/productos',
    transformer: transformers.array,
    crud: true
  },
  excepcionDisponibilidad: {
    url: '/excepciones-disponibilidades',
    transformer: transformers.array,
    crud: true
  },
  modulos: {
    url: '/modulos',
    transformer: transformers.array,
    crud: true
  },
  permisosPorModulo: {
    url: '/modulos/:id/permisos',
    transformer: transformers.array
  },
  grafoFamiliaProducto: {
    url: '/familias-productos/grafo/:id',
    transformer: transformers.object
  },
  search: {
    url: '/ruc/buscar/:parametro',
    transformer: transformers.object
  },
  familiasProducto: {
    url: '/familias-productos/:id',
    transformer: transformers.array,
    crud: true
  },
  familiasProductoPadres: {
    url: '/familias-productos/padres',
    options: {
      method: 'post'
    },
    transformer: transformers.array
  },
  abrirPeriodoNomina: {
    url: '/periodos-nominas/:id/abrir',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  procesarMovimiento: {
    url: '/movimientos-nominas/:id/procesar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  cerrarPeriodoNomina: {
    url: '/periodos-nominas/:id/cerrar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  aprobarDetalleAsistencia: {
    url: '/asistencias-detalles/:id/aprobar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  anularAsistencia: {
    url: '/asistencias/:id/anular',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  desaprobarDetalleAsistencia: {
    url: '/asistencias-detalles/:id/desaprobar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  procesarAsistencia: {
    url: '/asistencias/:id/procesar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  procesarSalario: {
    url: '/salarios/:id/procesar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  formasPago: {
    url: '/formas-pago',
    transformer: transformers.array
  },
  marcasTarjetas: {
    url: '/marcas-tarjetas',
    transformer: transformers.array
  },
  emisoresTarjetas: {
    url: '/emisores-tarjetas',
    transformer: transformers.array
  },
  procesadorasTarjetas: {
    url: '/procesadoras-tarjetas',
    transformer: transformers.array
  },
  aprobarDetalleComision: {
    url: '/comisiones-empleado-detalles/:id/aprobar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  desaprobarDetalleComision: {
    url: '/comisiones-empleado-detalles/:id/desaprobar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  procesarComision: {
    url: '/comisiones-empleado/:id/procesar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  anularComision: {
    url: '/comisiones-empleado/:id/anular',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  recuperarComisiones: {
    url: '/comisiones-empleado/no-cobradas',
    options: {
      method: 'post'
    },
    transformer: transformers.array
  },
  liquidarComisiones: {
    url: '/comisiones-empleado/:id/liquidar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  comisionesAprobarTodos: {
    url: '/comisiones-empleado/:id/aprobar-todos',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  generarComisionesPorPeriodo: {
    url: '/comisiones-empleado/generar-por-periodo',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  asignarCaja: {
    url: '/cajas/:id/asignar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  currentFondoFijo: {
    url: '/fondos-fijo/current',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  abrirCaja: {
    url: '/cajas/:id/abrir',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  cerrarCaja: {
    url: '/cajas/:id/cerrar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  confirmarCita: {
    url: '/citas/:id/confirmar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  agenda: {
    url: '/citas/agenda',
    options: {
      method: 'post'
    },
    transformer: transformers.array
  },
  verificarDisponibilidad: {
    url: '/citas/check-disponibilidad',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  agendaDiaria: {
    url: '/citas/agenda-diaria',
    options: {
      method: 'post'
    },
    transformer: transformers.array
  },
  cancelarCita: {
    url: '/citas/:id/cancelar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  cancelarTurno: {
    url: '/turnos/:id/cancelar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  cancelarTurnoDetalle: {
    url: '/turnos/:id/cancelar-detalle',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  especialistasDisponiblesServicio: {
    url: '/turnos/especialistas-disponibles-servicio',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  buildInfo: {
    url: '/build/info',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  concretarTurno: {
    url: '/turnos/:id/concretar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  concretarCita: {
    url: '/citas/:id/concretar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  cancelarOrden: {
    url: '/ordenes-de-trabajo/:id/cancelar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  finalizarOrden: {
    url: '/ordenes-de-trabajo/:id/finalizar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  reabrirOrden: {
    url: '/ordenes-de-trabajo/:id/re-abrir',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  facturaDeOrden: {
    url: '/ordenes-de-trabajo/:id/factura',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  procesarComisionOrden: {
    url: '/ordenes-de-trabajo/:id/procesar-comision',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  canjearGiftcardMonto: {
    url: '/ordenes-de-trabajo/:id/canjear-gifcard-monto',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  canjearGiftcardGentileza: {
    url: '/ordenes-de-trabajo/canjear-gifcard-gentileza',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  reprocesarComisionPaquete: {
    url: '/ordenes-de-trabajo-detalles/:id/reprocesar-comision-paquete',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  iniciarDetalle: {
    url: '/ordenes-de-trabajo-detalles/:id/iniciar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  terminarDetalle: {
    url: '/ordenes-de-trabajo-detalles/:id/terminar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  autorizarDetalle: {
    url: '/ordenes-de-trabajo-detalles/:id/autorizar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  autorizarOrden: {
    url: '/ordenes-de-trabajo/:id/autorizar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  actualizarEspecialistaDetalle: {
    url: '/ordenes-de-trabajo-detalles/:id/actualizar-especialista',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  insumosControlados: {
    url: '/ordenes-de-trabajo-detalles/:id/insumos-controlados',
    options: {
      method: 'post'
    },
    transformer: transformers.array
  },
  finalizadasClientes: {
    url: '/ordenes-de-trabajo-detalles/:id/finalizadas-cliente',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  procesarComisionServicio: {
    url: '/ordenes-de-trabajo-detalles/:id/procesar-comision',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  cancelarDetalle: {
    url: '/ordenes-de-trabajo-detalles/:id/cancelar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  cancelarDetalleProducto: {
    url: '/ordenes-de-trabajo-detalles/:id/cancelar-producto',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  actualizarDetalle: {
    url: '/ordenes-de-trabajo-detalles/:id/actualizar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  ordenesDetallePendientes: {
    url: '/ordenes-de-trabajo-detalles/pendientes',
    options: {
      method: 'post'
    },
    transformer: transformers.array
  },
  ordenesDetallePendientesTableroTrabajo: {
    url: '/ordenes-de-trabajo-detalles/pendientes-tablero-trabajo',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  clientesOrdenesDetallePendientes: {
    url: '/ordenes-de-trabajo-detalles/clientes-pendientes',
    options: {
      method: 'post'
    },
    transformer: transformers.array
  },
  clientesOrdenesFinalizadas: {
    url: '/ordenes-de-trabajo/clientes-finalizadas',
    options: {
      method: 'post'
    },
    transformer: transformers.array
  },
  abiertasClientes: {
    url: '/ordenes-de-trabajo/abiertas-cliente',
    options: {
      method: 'post'
    },
    transformer: transformers.array
  },
  agregarDetalleOrden: {
    url: '/ordenes-de-trabajo/:id/agregar-detalle',
    options: {
      method: 'post'
    },
    transformer: transformers.array
  },
  agregarDetalleProductoOrden: {
    url: '/ordenes-de-trabajo/:id/agregar-detalle-producto',
    options: {
      method: 'post'
    },
    transformer: transformers.array
  },
  anularFactura: {
    url: '/facturas/:id/anular',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  registrarFacturaAnulada: {
    url: '/facturas/registrar-anulacion',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  cobrarFactura: {
    url: '/facturas/:id/cobrar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  cobrarCuota: {
    url: '/cuotas/:id/cobrar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  crearPrecioDetalle: {
    url: '/precios/:id/detalles',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  editarPrecioDetalle: {
    url: '/precios/:id/detalles',
    options: {
      method: 'put'
    },
    transformer: transformers.object
  },
  eliminarPrecioDetalle: {
    url: '/precios/detalles/:id',
    options: {
      method: 'delete'
    },
    transformer: transformers.object
  },
  crearProductoDetalle: {
    url: '/productos/:id/detalles',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  editarProductoDetalle: {
    url: '/productos/:id/detalles',
    options: {
      method: 'put'
    },
    transformer: transformers.object
  },
  eliminarProductoDetalle: {
    url: '/productos/detalles/:id',
    options: {
      method: 'delete'
    },
    transformer: transformers.object
  },


  rectificarTransaccion: {
    url: '/transacciones/:id/rectificar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  reversarFactura: {
    url: '/facturas/:id/reversar-pagos',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  actualizarNumeroFactura: {
    url: '/facturas/:id/actualizar-numero',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  cerrarSaldoPendiente: {
    url: '/giftcards/:id/cerrar-saldo-pendiente',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  anularNotaCredito: {
    url: '/notas-credito/:id/anular',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  aplicarNotaCredito: {
    url: '/notas-credito/:id/aplicar',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  timbradosVigentes: {
    url: '/timbrados/vigentes',
    options: {
      method: 'post'
    },
    transformer: transformers.array
  },
  aprobarPorTipo: {
    url: '/asistencias/:id/aprobar-por-tipo',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  generarAsistenciaPorPeriodo: {
    url: '/asistencias/generar-por-periodo',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  generarSalarioPorPeriodo: {
    url: '/salarios/generar-por-periodo',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  categoriasProductos: {
    url: '/categorias-productos',
    transformer: transformers.array
  },
  tiposImpuestos: {
    url: '/tipos-impuestos',
    transformer: transformers.array
  },
  familiasProductos: {
    url: '/familias-productos',
    transformer: transformers.array
  },
  proveedores: {
    url: '/proveedores',
    transformer: transformers.array
  },
  clientes: {
    url: '/clientes',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  atributosClientes: {
    url: '/atributos-cliente',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  productoAdicional: {
    url: '/producto-adicional',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  atributosClientesUpdate: {
    url: '/atributos-cliente/:id',
    options: {
      method: 'put'
    },
    transformer: transformers.object
  },
  ruc: {
    url: '/ruc',
    transformer: transformers.array
  },
  procesosBatch: {
    url: '/procesos-batch',
    transformer: transformers.array
  },
  clientesValor: {
    url: '/clientes',
    transformer: transformers.array,
    crud: true
  },
  ordenes: {
    url: '/ordenes-de-trabajo',
    transformer: transformers.array,
    crud: true
  },
  ordenesDetalles: {
    url: '/ordenes-de-trabajo-detalles',
    transformer: transformers.array,
    crud: true
  },
  notasCredito: {
    url: '/notas-credito',
    transformer: transformers.array,
    crud: true
  },
  datosGrafico: {
    url: '/estadisticas/datos-grafico',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  marcas: {
    url: '/marcas',
    transformer: transformers.array
  },
  tipos_atributo_cliente: {
    url: '/tipos-atributos-cliente',
    transformer: transformers.array
  },
  atributos_cliente: {
    url: '/atributos-cliente',
    transformer: transformers.array
  },
  unidadesMedidas: {
    url: '/unidades-medidas',
    transformer: transformers.array
  },
  adicionales: {
    url: '/adicionales',
    transformer: transformers.array
  },
  productos: {
    url: '/productos',
    transformer: transformers.array
  },
  allClientes: {
    url: '/clientes',
    transformer: transformers.array
  },
  allSesionesCaja: {
    url: '/sesiones-cajas',
    transformer: transformers.array
  },
  especialidades: {
    url: '/especialidades',
    transformer: transformers.array
  },
  tiposAtributoClienteRequeridos: {
    url: '/tipos-atributos-cliente',
    transformer: transformers.array
  },
  turnosTrabajos: {
    url: '/turnos-trabajos',
    transformer: transformers.array
  },
  empleados: {
    url: '/empleados',
    transformer: transformers.array
  },
  configuracionesMarcaciones: {
    url: '/configuraciones-marcaciones',
    transformer: transformers.array
  },
  reports: {
    url: '/:endpoint/report/datatables',
    urlOptions: {
      arrayFormat: 'repeat'
    },
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  generarAsistencia: {
    url: '/asistencias/generar',
    options: {
      method: 'post'
    },
    transformer: transformers.array
  },
  turnosPendientes: {
    url: '/turnos/pendientes',
    options: {
      method: 'post'
    },
    transformer: transformers.array
  },
  ordenesPendientesSesionActual: {
    url: '/cajas/:cajaActualId/ordenes-pendientes-sesion-actual',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  facturasPendientesCobroSesionActual: {
    url: '/cajas/:cajaActualId/facturas-pendientes-cobro-sesion-actual',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  turnosPendientesTableroTrabajo: {
    url: '/turnos/pendientes-tablero-trabajo',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  },
  clientesCumpleanhos: {
    url: '/clientes/clientes-cumpleanhos',
    options: {
      method: 'post'
    },
    transformer: transformers.array
  },
  cotizacionVigente: {
    url: '/cotizaciones/vigente',
    options: {
      method: 'post'
    },
    transformer: transformers.object
  }
};


/**
 * Generamos los actions-creators/reducers para interoperar con el backend.
 */
export default reduxApi(routes)
  .use('rootUrl', config.serverURL)
  .use('options', (url, params, getState) => {
    let accessToken = getState().login.accessToken;
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken.token}`
    };
    return { headers, getState };
  })
  .use('fetch', adapterFetch(fetch));


// creamos un adapter para fetch que nos permita hacer retry de los
// request que obtuvieron 401
function adapterFetch(fetch) {
  return function(url, opts) {
    return fetch(url, opts)
        .then(resp => toJSON(resp)
          .then((response) => {
            if (resp.status >= 200 && resp.status < 300) {
              if (response.code && response.data) {
                return response.data;
              } else {
                return response;
              }
            } else if (resp.status === 401) {
              refreshToken(opts.getState());
            }
            return Promise.reject(response);
          })
      ).catch((e) => {
        if (e.message === 'Failed to fetch' || e.message === 'Application abort request') {
          throw new Error('Ha ocurrido un error');
        } else {
          throw e;
        }
      });
  };
}

function toJSON(resp) {
  return resp.text().then((data) => {
    try {
      return JSON.parse(data);
    } catch (err) {
      return data;
    }
  });
}


function refreshToken(state) {
  // buscamos renovar el access_token actual.
  let accessToken = state.login.accessToken;
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken.token}`
  };
  const body = {
    refreshToken: accessToken.refreshToken,
    grantType: 'refresh_token'
  };
  fetch(`${config.serverURL}/jwt/token`, {
    headers,
    method: 'POST',
    body: JSON.stringify(body)
  }).then(function(response) {
    response.json().then((accessToken) => {
      angular.element(document)
        .injector().invoke(['TokenService', function(TokenService) {
          TokenService.setToken(accessToken);
        }]);
    }).catch(() => {
    });
  }).catch((e) => {
    if (e.message === 'Failed to fetch' || e.message === 'Application abort request') {
      throw new Error('Ha ocurrido un error');
    } else {
      throw e;
    }
  });
}



// WEBPACK FOOTER //
// ./src/core/api/rest.js